<tec-modal
    [isVisible]="true"
    [title]="('WORKFLOWS.FORM.GENERAL.DETAIL' | translate) + ' ' + (resolveDocTitle(doc) | translate)"
    (closeEvent)="closeModal()"
>
    <!-- TABS -->
    <tec-tabs [tabs]="tabs" />

    <!-- TAB: CONFIG -->
    @if (tabs.length && tabs[0].selected) {
    <div class="item-group">
        <div class="grid grid-i2">
            <tec-info-group [label]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.GET_METHOD' | translate">
                <span>{{ `WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.${doc?.docInfo?.confRecommended?.connection_available ? 'AUTO' : 'MANUAL'}` | translate }}</span>
            </tec-info-group>

            <!-- CONEXIONES -->
            @if (doc?.docInfo?.confRecommended?.connection_available) {
                <tec-info-group [label]="'WORKFLOWS.FORM.OPERATIONS.FALLBACK' | translate">
                    {{ 'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.ATTACH' | translate }}
                </tec-info-group>
            } @else {
                <tec-info-group [label]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.CAPTURE_TYPE' | translate">
                    @if (doc?.method === 'both' || doc?.method === 'manual') {
                    <tec-tag [label]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.ATTACH' | translate" />
                    } @if (doc?.method === 'both' || doc?.method === 'photo') {
                    <tec-tag [label]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.PHOTO' | translate" />
                    }
                </tec-info-group>
            }
        </div>

        <!-- NIF-993: Nº intentos visible para todos los tipos no-conexión; min/max/cotejo solo GENERIC -->
        @if (!doc?.docInfo?.confRecommended?.connection_available) {
            <tec-divider />

            <div class="grid grid-i3">
                <tec-info-group
                    [label]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.NUM_TRIED' | translate"
                    [tooltip]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.NUM_TRIED_TOOLTIP' | translate"
                >
                    <tec-badge [label]="doc.total_tries" type="square" />
                </tec-info-group>

                @if (doc.type === 'GENERIC') {
                    <tec-info-group
                        [label]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.NUM_MIN_DOC' | translate"
                        [tooltip]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.NUM_MIN_DOC_TOOLTIP' | translate"
                    >
                        <tec-badge [label]="doc.min" type="square" />
                    </tec-info-group>

                    <tec-info-group
                        [label]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.NUM_MAX_DOC' | translate"
                        [tooltip]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.NUM_MAX_DOC_TOOLTIP' | translate"
                    >
                        <tec-badge [label]="doc.max" type="square" />
                    </tec-info-group>

                    <tec-info-group
                        [label]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.COMPARE_DATA' | translate"
                        [tooltip]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.COMPARE_DATA_TOOLTIP' | translate"
                    >
                        @if (doc.preview_validation) {
                        <tec-tag
                            [label]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.ACTIVE' | translate"
                            status="success"
                        ></tec-tag>
                        } @else {
                        <tec-tag
                            [label]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.INACTIVE' | translate"
                            status="default"
                        ></tec-tag>
                        }
                    </tec-info-group>
                }
            </div>
        }
    </div>
    }

    <!-- TAB: INSTRUCTIONS -->
    @if (tabs.length && tabs[1].selected) {
    <div class="item-group">
        <tec-info-group [label]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.DOC_NAME' | translate">
            @if (doc?.title) {
                <app-text-locale-preview [textLocale]="doc.title" />
            } @else {
                <span>{{ `DOCS.${doc?.type?.toUpperCase()}` | translate }}</span>
            }
        </tec-info-group>

        <tec-divider />

        <span>{{ 'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.ATTACH_DOCUMENT' | translate | uppercase }}</span>

        <tec-info-group
            [label]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.DESCRIPTION' | translate"
            [tooltip]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.ATTACH_DOCUMENT_DESCRIPTION' | translate"
        >
            @if (doc?.description) {
                <app-text-locale-preview [textLocale]="doc.description" />
            } @else {
                <span>{{ `DOCS.${doc?.type?.toUpperCase()}_DESCRIPTION` | translate }}</span>
            }
        </tec-info-group>

        <tec-info-group
            [label]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.INSTRUCTIONS' | translate"
            [tooltip]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.ATTACH_DOCUMENT_INSTRUCTIONS' | translate"
        >
            @if (doc?.instructions) {
                <app-text-locale-preview [textLocale]="doc.instructions" />
            } @else {
                <span>
                    <span [outerHTML]="(`DOCS.${doc?.type?.toUpperCase()}_INSTRUCTIONS` | translate)"></span>
                </span>
            }
        </tec-info-group>

        <!-- <tec-divider />

        <span>{{ 'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.TAKE_PHOTO' | translate | uppercase }}</span>

        <tec-info-group
            [label]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.DESCRIPTION' | translate"
            [tooltip]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.TAKE_PHOTO_DESCRIPTION' | translate"
        >
            <span>
                <span
                    [outerHTML]="doc?.instructions_photo || (`DOCS.${doc?.type?.toUpperCase()}_INSTRUCTIONS` | translate)"
                ></span>
            </span>
        </tec-info-group> -->
    </div>
    }
</tec-modal>
